import { RouterProvider } from "react-router-dom";
import { useEffect, useMemo } from "react";
import { ThemeProvider } from "react-jss";
import { useAppSelector, useAppDispatch } from "./hooks";
import { fetchTheme } from "./slices/theme";
import { createApolloClient } from "@onmo/graphql";
import { ApolloProvider } from "@apollo/client";
import { HtmlGameProvider } from "@onmo/html-game";
import { router } from "./routes";
import { AppReloadPrompt } from "./components/common/AppReloadPrompt/AppReloadPrompt";
import { selectAuthReady } from "@onmo/auth";

function App() {
  const { theme } = useAppSelector((state) => state.theme);
  const dispatch = useAppDispatch();
  const authReady = useAppSelector(selectAuthReady);

  const apolloClient = useMemo(() => {
    return createApolloClient();
    // Need authReady because we need to get the token
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authReady]);

  useEffect(() => {
    dispatch(fetchTheme());
  }, [dispatch]);

  return (
    <ThemeProvider theme={theme}>
      <ApolloProvider client={apolloClient}>
        <HtmlGameProvider>
          <RouterProvider router={router} />
        </HtmlGameProvider>
      </ApolloProvider>
      <AppReloadPrompt />
    </ThemeProvider>
  );
}

export default App;
